import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IDealerInformationVDF, IPKIMEIReportRequest, IPKIMEIReportResponse } from '../models/model'

export class PKIMEIDataReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/vodafoneDealer/getPKIMEIData',
      requesterInfo,
    })
  }

  public async getPKIMEIData(req: IPKIMEIReportRequest): Promise<IPKIMEIReportResponse> {
    return await this.postAsync<IPKIMEIReportResponse>(req)
  }
}
